import { Confirm, Pagination } from 'semantic-ui-react';
import React, { useMemo, useState } from 'react';
import AsyncPageContent from '../../../../common/components/page/AsyncPageContent';
import { ControlContainer, PageHeader } from 'common/styles/page';
import { StyledAddButton, StyledTrashButton } from 'common/components/button/StyledButton';
import {
  HeaderCell,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from 'common/components/Table';

const PAGE_SIZE = 10;

type FoundationsListTableProps = {
  title: string;
  projects: any[];
  isLoading: boolean;
  error: any;
  onItemDeleteConfirm: (projectId: number) => void;
  onItemClick: (projectId: number) => void;
  onAddClick: () => void;
};
export const FoundationsListTable = (props: FoundationsListTableProps) => {
  const { title, projects, isLoading, error, onItemDeleteConfirm, onItemClick, onAddClick } = props;

  const [page, setPage] = useState(1);
  const [projectToDeleteId, setProjectToDeleteId] = useState(null);

  const currentPageProjects = useMemo(
    () => projects.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [page, projects]
  );

  const confirmDelete = (teamProjectId: any) => {
    setProjectToDeleteId(teamProjectId);
  };

  const finalizeDelete = () => {
    if (projectToDeleteId === null) {
      return;
    }
    onItemDeleteConfirm(projectToDeleteId);
    setProjectToDeleteId(null);
  };

  const sortedProjects = useMemo(
    () =>
      [...currentPageProjects].sort((a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
      ),
    [currentPageProjects]
  );

  return (
    <AsyncPageContent isLoading={isLoading} error={error}>
      <PageHeader
        title={title}
        controls={
          <ControlContainer>
            <StyledAddButton label="Add Template" onClick={onAddClick} width="160" />
          </ControlContainer>
        }
      />
      <Table selectable>
        <TableHeader>
          <TableRow>
            <HeaderCell width={5}>Template</HeaderCell>
            <HeaderCell width={9}>Description</HeaderCell>
            <HeaderCell width={2} justify="center">
              Actions
            </HeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {sortedProjects.map((project: any) => (
            <TableRow
              key={project.id}
              onClick={() => onItemClick(project.id)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell $firstcol>{project.name}</TableCell>
              <TableCell>
                <div title={project?.template?.description}>
                  {project?.template?.description.length > 240
                    ? `${project?.template?.description.slice(0, 240)}...`
                    : project?.template?.description}
                </div>
              </TableCell>
              <TableCell justify="center">
                <StyledTrashButton 
                  onClick={confirmDelete} 
                  id={project.id}
                  disabled={project.in_use === true}
                  title={project.in_use === true ? "Template In-use" : "Delete template"}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div style={{ justifyContent: 'right', display: 'flex', marginTop: '20px' }}>
        <Pagination
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          activePage={page || 1}
          totalPages={Math.ceil(projects.length / PAGE_SIZE)}
          onPageChange={(event, value) => setPage(value.activePage as number)}
          boundaryRange={0}
          size="mini"
        />
      </div>

      <Confirm
        open={projectToDeleteId !== null}
        onCancel={() => setProjectToDeleteId(null)}
        onConfirm={finalizeDelete}
        content={'Are you sure you want to delete this template?'}
      />
    </AsyncPageContent>
  );
};
